import { AbsoluteFill } from "remotion";
import { useAudioTracks } from "../hooks/use-audio-tracks";
import { AudioEngineResolved } from "../audio-visualizer/components/audio-engine";
import { BackgroundLayer } from "../audio-visualizer/components/background-layer";
import { AudioSpectrum } from "./component";
import { AudioSpectrumProps } from "./constants";

export const MainComposition: React.FC<AudioSpectrumProps> = ({
    audioTracks,
    backgroundUrl,
    spectrum,
    title,
    isTest,
}) => {
    const { isValid } = useAudioTracks({ audioTracks });

    if (!isValid) {
        return (
            <AbsoluteFill
                style={{
                    backgroundColor: "#000",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <div style={{ color: "white", fontFamily: "sans-serif" }}>
                    No audio tracks provided.
                </div>
            </AbsoluteFill>
        );
    }

    return (
        <AbsoluteFill>
            {/* 1. Audio Playback Engine */}
            <AudioEngineResolved audioTracks={audioTracks} />

            {/* 2. Visuals */}
            <BackgroundLayer url={backgroundUrl} seed={0} />

            {/* 3. Audio Spectrum Visualizer */}
            <AudioSpectrum
                audioTracks={audioTracks}
                spectrum={spectrum}
                title={title}
                backgroundUrl={backgroundUrl}
                isTest={isTest}
            />
        </AbsoluteFill>
    );
};
